module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.package) ? _c('div', {
    staticClass: "banner-popup"
  }, [(_vm.active === 3) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['popup', {
      'active2': _vm.active >= 2
    }, {
      'active3': _vm.active === 3
    }]
  }, [_c('img', {
    staticClass: "expand-collapse",
    attrs: {
      "src": "/static/activityImg/open.svg",
      "alt": "expand-collapse"
    },
    on: {
      "click": _vm.expandCollapse
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    on: {
      "click": _vm.goto
    }
  }, [_c('img', {
    staticClass: "theme",
    attrs: {
      "src": "/static/activityImg/theme.png",
      "alt": "theme"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "package-info"
  }, [(_vm.active >= 2) ? _c('div', {
    staticClass: "name-type"
  }, [_vm._v("\n          " + _vm._s(_vm.getPackageName(_vm.package.name)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.active >= 2) ? _c('div', {
    staticClass: "given-days"
  }, [(_vm.package.given_days > 0) ? _c('span', [_vm._v(_vm._s(_vm.getGivenMonthsOrDays(_vm.package.given_days)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('p', {
    staticClass: "price-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)))]), _c('span', [_vm._v(_vm._s(_vm.package.device_average_price))])]), _vm._v(" "), _c('p', {
    staticClass: "month-device"
  }, [_vm._v("/" + _vm._s(_vm.$t("month")) + "/" + _vm._s(_vm.$t("device")))])]), _vm._v(" "), _c('div', {
    staticClass: "off-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.getDiscount(_vm.package)))]), _vm._v(" "), _c('span', [_vm._v("OFF")])]), _vm._v(" "), (_vm.active >= 2) ? _c('p', {
    staticClass: "sale-price"
  }, [(_vm.package.price !== _vm.package.list_price) ? _c('span', {
    staticClass: "origin-price"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)) + _vm._s(_vm.package.list_price))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)) + _vm._s(_vm.package.price))])]) : _vm._e(), _vm._v(" "), _c('button', [_vm._v(_vm._s(_vm.$t("getNow")))]), _vm._v(" "), (_vm.active >= 2 && (_vm.package.can_topup || _vm.package.can_subscribe)) ? _c('CountDown', {
    attrs: {
      "end-time": _vm.package.expired_at
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('img', {
    staticClass: "get",
    attrs: {
      "src": "/static/activityImg/ic_right.svg",
      "alt": "get"
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30deb58d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannerPopup/BannerPopup.vue
// module id = 1296
// module chunks = 1